const optimizelyEvents = {
  userEngage: {
    op: "dyh_user_engage",
  },
  signIn: {
    op: "dyh_login_navigate",
  },
  styleQuiz: {
    complete: {
      op: "dyh_style_quiz_complete",
    },
  },
  roomPage: {
    visit: {
      op: "dyh_room_page_visit",
    },
    save: {
      op: "dyh_room_page_save",
    },
    addProduct: {
      op: "dyh_room_page_add_product",
    },
  },
};

export default optimizelyEvents;
